import React, { useState } from "react"

import Typography from "@material-ui/core/Typography"
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers/"
import MomentUtils from "@date-io/moment"

import useStyles from "./input.style"
import { useTheme } from "@material-ui/styles"
import { Link } from "gatsby"

export default function Input({
  shouldDisplayError,
  inputProps,
  errorLabel,
  dropdown,
  items,
  dateInput,
  onDropdownItemClick,
  ...props
}) {
  const classes = useStyles(props)
  const theme = useTheme()

  const [inputFocused, setInputFocused] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [listHovered, setListHovered] = useState(false)

  const onFocus = () => {
    setInputFocused(true)
    dropdown && setDropdownOpen(true)
  }

  const onBlur = () => {
    if (dropdownOpen) {
      setInputFocused(true)
    } else {
      setInputFocused(false)
    }
  }

  const renderDropdownResult = item => {
    return (
      <div
        className={classes.dropdownListItem}
        // onClick={() => {
        //   onDropdownItemClick(item)
        //   setDropdownOpen(false)
        //   setInputFocused(false)
        // }}
      >
        <Link
          style={{ color: "initial" }}
          href={`/${item.category.name === "Blog" ? "blog/" : ""}${
            item.seo.slug
          }`}
        >
          <Typography variant="body1" color="initial">
            {item.name}
          </Typography>
        </Link>
      </div>
    )
  }

  const inputStyle = {
    border:
      errorLabel || shouldDisplayError
        ? `1px solid #FF5630`
        : inputFocused
        ? `1px solid ${theme.palette.primary.main}`
        : `1px solid #EBEBEB`,
    borderRadius: 4,
  }

  const [selectedDate, handleDateChange] = React.useState(new Date())

  return (
    <div style={{ position: "relative" }}>
      {dateInput ? (
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <KeyboardDatePicker
            id="date"
            className={`${classes.inputRemade}`}
            style={inputStyle}
            value={selectedDate}
            placeholder="10/10/2018"
            onChange={date => handleDateChange(date)}
            minDate={new Date()}
            format="MM/dd/yyyy"
          />
        </MuiPickersUtilsProvider>
      ) : (
        <input
          className={classes.input}
          id="input"
          {...inputProps}
          margin={props.margin}
          dropdown={dropdown}
          onFocus={onFocus}
          onBlur={onBlur}
          inputFocused={inputFocused}
          listHovered={listHovered}
          onChange={e => inputProps.onChange(e.target.value)}
          style={inputStyle}
        />
      )}

      {errorLabel && (
        <div className={classes.errorWrapper}>
          <Typography
            variant="subtitle2"
            color="inherit"
            id="input_error_message"
          >
            {errorLabel}
          </Typography>
        </div>
      )}
      {dropdownOpen && dropdown && items && !!items.length && (
        <div
          className={classes.dropdownList}
          onMouseEnter={() => setListHovered(true)}
          onMouseLeave={() => setListHovered(false)}
          height={items && items.length * 35 + "px"}
        >
          {items && items.map(item => renderDropdownResult(item))}
        </div>
      )}
    </div>
  )
}
